import React from 'react'
import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export type SelfCheckinPageSubtitleProps = {
  title: React.ReactNode
  description?: React.ReactNode
}

export const SelfCheckinPageSubtitle: React.FC<SelfCheckinPageSubtitleProps> = ({ title, description }) => (
  <div css={containerStyle}>
    <div css={titleStyle}>{title}</div>
    {description && <div css={descriptionStyle}>{description}</div>}
  </div>
)

const containerStyle = css({ textAlign: 'center' })

const titleStyle = css(
  {
    fontSize: 22,
    fontWeight: 500,
    lineHeight: '30px',
    letterSpacing: '1.1px',
    whiteSpace: 'pre-line',
  },
  createSelfCheckinResponsiveStyle({
    portrait: { fontSize: 22 },
    landscape13: {
      fontSize: 26,
      lineHeight: '35px',
      letterSpacing: '1.3px',
    },
  }),
)

const descriptionStyle = css(
  {
    marginTop: 8,
    color: '#676767',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '22px',
    letterSpacing: '0.8px',
    whiteSpace: 'pre-line',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 20, lineHeight: '27px', letterSpacing: '1px' },
  }),
)
